import { PropTypes } from 'prop-types';
import React from 'react';
import createSvgIcon from '../createSvgIcon';

const Report = ({
  variant
}) => {
  const solid = /*#__PURE__*/React.createElement("path", {
    d: "M50,30.65,38.3,23V21.48L50,13.83V9.21C50,8.38,49.56,8,48.72,8H15.28C14.44,8,14,8.38,14,9.21v5.88h0V56h4V36.48H48.72c.84,0,1.28-.39,1.28-1.22Z",
    "data-name": "Laag 1"
  });
  const outline = /*#__PURE__*/React.createElement("path", {
    d: "M50,30.65,38.3,23V21.48L50,13.83V9.21C50,8.38,49.56,8,48.72,8H15.28C14.44,8,14,8.38,14,9.21v5.88h0V56h4V36.48H48.72c.84,0,1.28-.39,1.28-1.22Zm-4,1.83H18V12H46L35.13,19.56a1.44,1.44,0,0,0-.83,1.33v2.66a1.48,1.48,0,0,0,.83,1.34L46,32.48Z",
    "data-name": "Laag 1"
  });
  const iconType = variant === 'solid' ? solid : outline;
  const Icon = createSvgIcon({
    title: 'Report',
    width: '25px',
    height: '25px',
    viewBox: '0 0 64 64',
    content: iconType
  });
  return /*#__PURE__*/React.createElement(Icon, null);
};

Report.propTypes = {
  variant: PropTypes.oneOf(['outline', 'solid'])
};
export default Report;